import React from 'react'

import {
  NewsItemWrap,
  NewsItemMeta,
  NewsItemTitle,
} from './styles'

import { Props } from './types'

const NewsItem: React.FC<Props> = ({
  date,
  linkUrl,
  source,
  title,
}): React.ReactElement => (
  <NewsItemWrap>
    <NewsItemMeta>
      {(date && <span>{date}</span>) || undefined}
      <span>
        <strong>{source}</strong>
      </span>
    </NewsItemMeta>
    <NewsItemTitle>
      <a href={linkUrl} target='_blank' rel='noopener noreferrer'>
        {title}
      </a>
    </NewsItemTitle>
  </NewsItemWrap>
)

export default NewsItem
